import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// UNSECURED LOAN INTEREST (RATE UPDATE) VERIFICATION
// Legacy: /Accounts/VerifyUnsLoanInterest (+ VerifyUnsLoanInterestGrid / VerifyUnsLoanInterestView).
// The view only echoes the queue row, so there is no separate detail endpoint.
// ==============================================

const headers = { 'Content-Type': 'application/json' };

const handle = (error) => {
    if (error.response?.data) throw error.response.data;
    throw error;
};

// Queue — interest-rate updates pending at this role's level (rows carry MOID).
export const getVerificationUnsLoanInterest = async (roleId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/GetVerificationUnsLoanInterest`, { params: { Roleid: roleId }, headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Verify / Approve / Reject (spApproveUnsLaonInterest — success literal "Submited").
export const approveUnsLoanInterest = async (payload) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/Accounts/ApproveUnsLaonInterest`, payload, { headers });
        return response.data;
    } catch (error) { return handle(error); }
};
